// Built-ins
import React from "react";

// Custom Made Components
import NavigationBar from "../../core/navigation_bar/navigation_bar";
import Footer from "../../core/footer/footer";
import axios from "axios";

// Modules / Functions
import filterFactory, { textFilter, selectFilter } from "react-bootstrap-table2-filter";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import Swal from "sweetalert2";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import AddProfessionalModal from "../../modals/create/add_professional";
import OverviewIdCell from "../../common/OverviewIdCell";

// CSS
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";

// Global Variables
import {
  paginationOptions,
  headers,
  pageHeader,
  loader,
} from "../../global_vars";

// Variables
window.Swal = Swal;

// API endpoint (use full list including inactive)
const ALL_PROFESSIONALS = "https://ultima.icsgr.com/api/data_management/professionals/";

const columns = [
  {
    dataField: "professional_id",
    text: "Professional ID",
    sort: true,
    filter: textFilter(),
    formatter: (cell, row) => <OverviewIdCell entity="professional" id={row.professional_id} />,
  },
  {
    dataField: "fullname",
    text: "Full name",
    sort: true,
    filter: textFilter(),
  },
  {
    dataField: "profession.title",
    text: "Profession",
    sort: true,
    filter: textFilter(),
    formatter: (cell, row) => row.profession?.title || "",
  },
  {
    dataField: "city.title",
    text: "City",
    sort: true,
    filter: textFilter(),
    formatter: (cell, row) => row.city?.title || "",
  },
  {
    dataField: "reliability",
    text: "Reliability",
    sort: true,
    filter: textFilter(),
  },
  {
    dataField: "afm",
    text: "AFM",
    sort: true,
    filter: textFilter(),
  },
  {
    dataField: "bank_details",
    text: "Bank details",
    sort: true,
    filter: textFilter(),
    formatter: (cell) => cell || "",
  },
  {
    dataField: "active",
    text: "Active",
    sort: true,
    filter: selectFilter({
      options: { "": "All", true: "Yes", false: "No" },
      defaultValue: "",
      onFilter: (filterVal, data) => {
        if (filterVal === "" || filterVal === undefined || filterVal === null) return data;
        return data.filter((row) => String(row.active) === String(filterVal));
      },
    }),
    formatter: (cell) => (cell ? "Yes" : "No"),
  },
];

const defaultSorted = [
  {
    dataField: "fullname",
    order: "asc",
  },
];

class AllProfessionals extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      all_professionals: [],
      is_loaded: false,
    };
  }

  fetchProfessionals = () => {
    const currentHeaders = {
      ...headers,
      "Authorization": "Token " + localStorage.getItem("userToken")
    };

    axios
      .get(ALL_PROFESSIONALS, {
        headers: currentHeaders,
      })
      .then((res) => {
        let allProfessionals = [];

        if (Array.isArray(res.data)) {
          allProfessionals = res.data;
        } else if (res.data && Array.isArray(res.data.results)) {
          allProfessionals = res.data.results;
        } else if (res.data && Array.isArray(res.data.data)) {
          allProfessionals = res.data.data;
        } else if (res.data && res.data.all_professionals) {
          allProfessionals = res.data.all_professionals;
        } else {
          console.warn('Unexpected API response structure:', res.data);
          allProfessionals = [];
        }

        this.setState({
          all_professionals: allProfessionals,
          is_loaded: true,
        });
      })
      .catch((e) => {
        console.error('Error fetching professionals:', e);
        if (e?.response?.status === 401) {
          this.setState({ forbidden: true });
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Failed to load professionals. Please try again.",
          });
        }
        this.setState({
          all_professionals: [],
          is_loaded: true,
        });
      });
  };

  componentDidMount() {
    this.fetchProfessionals();
  }

  render() {
    const tableData = Array.isArray(this.state.all_professionals) ? this.state.all_professionals : [];

    return (
      <>
        <NavigationBar />
        <div className="mainContainer">
          {pageHeader("all_professionals")}
          <div className="contentContainer">
            <div className="contentBody">
              {this.state.is_loaded ? (
                <>
                  <ToolkitProvider
                    bootstrap4
                    keyField="professional_id"
                    data={tableData}
                    columns={columns}
                    search
                    condensed
                  >
                    {(props) => (
                      <div>
                        <BootstrapTable
                          {...props.baseProps}
                          pagination={paginationFactory(paginationOptions)}
                          filter={filterFactory()}
                          defaultSorted={defaultSorted}
                          hover
                          bordered={false}
                          striped
                        />
                      </div>
                    )}
                  </ToolkitProvider>
                  <div className="contentHeader">
                    <AddProfessionalModal onProfessionalCreated={this.fetchProfessionals} />
                  </div>
                </>
              ) : (
                <div>{loader()}</div>
              )}
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

export default AllProfessionals;
